/**
 * Dual-handle price range slider built on two native range inputs.
 * Touch and keyboard support come for free; the facet form reads the mirrored
 * text inputs, and the native change event bubbles up to trigger the fetch.
 */
{
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initSlider = (slider) => {
    if (slider.dataset.rangeSliderInit) return;
    slider.dataset.rangeSliderInit = 'true';

    const handleMin = slider.querySelector('.range-input-min');
    const handleMax = slider.querySelector('.range-input-max');
    if (!handleMin || !handleMax) return;

    const box = slider.closest('.range-box') ?? slider.parentElement;
    const fieldMin = box?.querySelector('.min-value');
    const fieldMax = box?.querySelector('.max-value');
    const fill = slider.querySelector('.range-fill');

    const min = Number(slider.dataset.min) || 0;
    const max = Math.max(Number(slider.dataset.max) || 0, min + 1);
    const span = max - min;

    const paint = () => {
      const low = Number(handleMin.value);
      const high = Number(handleMax.value);

      if (fill) {
        fill.style.left = `${((low - min) / span) * 100}%`;
        fill.style.width = `${((high - low) / span) * 100}%`;
      }
      if (fieldMin) fieldMin.value = low;
      if (fieldMax) fieldMax.value = high;

      // Lift the lower handle above the upper one once they meet near the top.
      handleMin.style.zIndex = low > min + span * 0.5 ? '5' : '3';
    };

    handleMin.addEventListener('input', () => {
      if (Number(handleMin.value) > Number(handleMax.value)) handleMin.value = handleMax.value;
      paint();
    });

    handleMax.addEventListener('input', () => {
      if (Number(handleMax.value) < Number(handleMin.value)) handleMax.value = handleMin.value;
      paint();
    });

    // Typing a value moves the matching handle back in sync.
    [
      [fieldMin, handleMin],
      [fieldMax, handleMax],
    ].forEach(([field, handle]) => {
      field?.addEventListener('change', () => {
        const value = clamp(Math.round(Number(field.value.replace(/\D/g, '')) || min), min, max);
        handle.value = value;
        if (Number(handleMin.value) > Number(handleMax.value)) {
          if (handle === handleMin) handleMin.value = handleMax.value;
          else handleMax.value = handleMin.value;
        }
        paint();
      });
    });

    paint();
  };

  const initPriceRangeSliders = () => {
    document.querySelectorAll('.slider-range[data-range-slider]').forEach(initSlider);
  };

  window.initPriceRangeSliders = initPriceRangeSliders;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceRangeSliders, { once: true });
  } else {
    initPriceRangeSliders();
  }
}
